import _ from 'lodash'
import isURL from 'validator/lib/isURL'
import regexpValidatorFactory from './regexp-validator-factory'

// from http://blog.mattheworiordan.com/post/13174566389/url-regular-expression-for-links-with-or-without (a more relaxed version that the jquery one from before)
const regexp = /((([A-Za-z]{0,9}:(?:\/\/(\/)?)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)$/
const legacyFn = regexpValidatorFactory(regexp,
	'bookmarks.bookmark.url.invalid.url.error.tooltip')

function urlValidator(value) {
	const validUrl = _.isEmpty(value) ||
		isURL(value, { require_protocol: true })
	if (!validUrl) {
		// URL validation isn't simple, and our old regex doesn't handle everything well
		// (e.g. google map urls) but in order to maintain backwards compatibility
		// if a url is not valid using validator.js we'll throw the old regex at it.
		return legacyFn(value)
	}
}

export default urlValidator

urlValidator.__filename__ = 'components/validators/url-validator.js'
